import type { RegionNode } from '../../../api/regions';

/**
 * The single region a viewer may write to, or null when they may write to
 * several (or none). A lone region is not a choice, so the Location step shows
 * it as a value rather than as a one-item dropdown — and a region with
 * subregions beneath it IS a choice, because any of them may be selected.
 */
export function soleRegion(regions: RegionNode[]): RegionNode | null {
  if (regions.length !== 1 || regions[0].children.length > 0) return null;
  return regions[0];
}
